import { AuthorizeButton } from "./AuthorizeButton";
import { JobsBadge } from "./JobsBadge";
import { OrgIndicator } from "./OrgIndicator";
import { ProjectIndicator } from "./ProjectIndicator";

/**
 * Top bar. Sits above the main content; reserved-right for the chrome
 * indicators (org, project, jobs, authorize). PRD-002 DoD-mandated
 * Authorize button is the rightmost action — discoverable from every
 * screen, switches between "Authorize" and "Authorized" affordances.
 */
export function TopBar() {
    return (
        <header className="app-topbar">
            <div className="brand" style={{ fontWeight: 600, color: "var(--n9)" }}>
                checklist-results
            </div>
            <div className="app-topbar-spacer" />
            <div className="app-topbar-right">
                <OrgIndicator />
                <ProjectIndicator />
                <JobsBadge />
                <AuthorizeButton />
            </div>
        </header>
    );
}
